export default __webpack_public_path__ + "static/media/img1.09a4627f.png";